const state = {
    accountId: null,
    loginName: null,
    companyId: null,
    companyName: null,
    accountType: null,
};

const mutations = {
    SET_ACCOUN_ID: (state, data) => {
        state.accountId = data;
        //   state.routes = constantRoutes.concat(menus)
    },
    SET_LOGIN_NAME: (state, data) => {
        state.loginName = data;
    },
    SET_COMPANY_ID: (state, data) => {
        state.companyId = data;
    },
    SET_COMPANY_NAME: (state, data) => {
        state.companyName = data;
    },
    SET_ACCOUNT_TYPE: (state, data) => {
        state.accountType = data; // 3 驻京办用户 ，2企业用户  
    },
};

const actions = {
    setAccountId({commit}, accountId) {
        console.log(accountId)
        commit('SET_ACCOUN_ID', accountId);
    },
    setLoginName({commit}, loginName) {
        console.log(loginName)
        commit('SET_LOGIN_NAME', loginName);
    },
    setCompanyId({commit}, companyId) {
        console.log(companyId)
        commit('SET_COMPANY_ID', companyId);
    },
    setCompanyName({commit}, companyName) {
        console.log(companyName)
        commit('SET_COMPANY_NAME', companyName);
    },
    setAccountType({commit}, accountType) {
        commit('SET_ACCOUNT_TYPE', accountType);
    },   
};

export default {
    state,
    mutations,
    actions,
};

